import { SET_CLIENT_SELECT, SET_COMPANY_SELECT, SET_BRANCH_SELECT, SET_USER_DATA, SET_USER_TYPE, SET_USER_ROLE } from "./actionType";

export const setClientSelect = (payload) => ({
  type: SET_CLIENT_SELECT,
  payload,
});

export const setCompanySelect = (payload) => ({
  type: SET_COMPANY_SELECT,
  payload,
});

export const setBranchSelect = (payload) => ({
  type: SET_BRANCH_SELECT,
  payload,
});

export const setUserData = (payload) => ({
  type: SET_USER_DATA,
  payload,
});

export const setUserType = (payload) => ({
  type: SET_USER_TYPE,
  payload,
});

export const setUserRole = (payload) => ({
  type: SET_USER_ROLE,
  payload,
});
